import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
  Select,
  Spin
} from "antd";
import { PageHeader } from '@ant-design/pro-components';

import { ExpandAltOutlined, EditOutlined } from "@ant-design/icons";
import { AlignType } from 'rc-table/lib/interface';

import { apiCand } from "../../../services/apiCand";

import { maskCpf } from "../../../utils/maskFunctions";

import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage } from "../../../utils/messages";
import { IPessoaFisica, IPessoaFisicaConsulta } from "../Componentes/InterfacePessoaFisica";

import "../style.css";
import { onlyNumbers } from "../../../utils/utilsFunctions";
import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { getEntidadesDoUsuarioConsultar } from "../../../auth/entidadeUsuario";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../parametrosUI";
import { limparPesquisaSalva, obterPesquisa, salvarPesquisa } from "../../../utils/contextoPesquisa";

const { Option } = Select;

const Consultar: React.FC<any> = (props: any) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [pessoaFisica, setPessoaFisica] = useState<IPessoaFisica>();
  const [pessoasFisicas, setPessoasFisicas] = useState<IPessoaFisicaConsulta[]>([]);

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const [manter, setManter] = useState(2); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 2 : Detalhar / 3 : Alterar;


  useEffect(() => {
    window.scrollTo(0, 0);

    const pesquisaSalva = obterPesquisa('pessoasFisicas');
    if (pesquisaSalva){
      setPessoasFisicas(pesquisaSalva.resultado);
      setTotalElements(pesquisaSalva.resultado.length);

      form.setFieldsValue({
        matriculaEfpc: pesquisaSalva.parametros.matriculaEfpc,
        nuCpf: maskCpf(pesquisaSalva.parametros.nuCpf),
        nmPessoaFisica: pesquisaSalva.parametros.nmPessoaFisica,

        entidade: pesquisaSalva.nmTextos.entidade,
      });
    }

    const entidadeUsuario = getEntidadesDoUsuarioConsultar();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        entidade: entidadeUsuario[0].sigla,
        matriculaEfpc: entidadeUsuario[0].matricula,
      });
    }
    
  }, []);

  useEffect(() => {
    if (pessoaFisica) pushToManter(pessoaFisica, manter);
  }, [pessoaFisica]);

  function pushToManter(oc: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: oc
    };

    navigate("/pessoa-fisica/manter", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      key: "cpf",
      width: 150,
      title: "CPF",
      dataIndex: "",
      render: (oc: IPessoaFisicaConsulta) => (
        <Input
          value={maskCpf(oc.nuCpf)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      key: "nome",
      // width: 400,
      title: "Nome Completo",
      dataIndex: "nmPessoaFisica",
    });

    cols.push({
      key: "entidade",
      width: 150,
      title: "Entidade",
      dataIndex: "",
      render: (pf: IPessoaFisicaConsulta) => (<>
        {pf.entidades.map((e, index) => (
          <React.Fragment key={index}>
            {index > 0 ? (<br/>) : (<></>) }
            {e.sigla}
          </React.Fragment>
       ))}
      </>)
    });

    cols.push({
      key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (oc: IPessoaFisicaConsulta) => (
        <>
          <ExpandAltOutlined style={{ color: "blue" }}
            // shape="round"
            id='detalhar'
            onClick={() => {
              setManter(2);
              getPessoaFisicaPorId(oc.idPessoaFisica);
            }}
          />

          {false && ( //As condições são mais complexas
            <EditOutlined style={{ color: "blue" }}
              id='alterar'
              onClick={() => {
                setManter(3);
                getPessoaFisicaPorId(oc.idPessoaFisica);
              }} />
          )}
        </>
      ),
    });

    return cols;
  }

  const columns = gerarColunas();

  const [entidades, setEntidades] = useState<IEntidade[]>([]);

  const handlerEntidade = async (value: any) => {
    if (value){
      form.setFieldsValue({
        entidade: value.children,
        matriculaEfpc: value.key,
      });
    } else {
      form.setFieldsValue({
        "matriculaEfpc": ''
      });
    }
  };

  const pessoaFisicaNaoEncontrado = () => {
    infoMessage("O sistema não encontrou resultado para consulta realizada");
  };

  const obterParametrosDoForm = () => {
    return {
        page: form.getFieldValue("pagina") || 0,
        limit: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE, //linhaPorPagina

        matriculaEfpc: onlyNumbers(form.getFieldValue("matriculaEfpc")) || "",
        nuCpf: onlyNumbers(form.getFieldValue("nuCpf")) || "",
        nmPessoaFisica: form.getFieldValue("nmPessoaFisica") || "",
    };
  }

  const getPessoaFisica = async () => {
    try {
      setLoading(true);

      const params = obterParametrosDoForm();
      let lQuery = `pessoasFisicas?${(new URLSearchParams(params)).toString()}`;
      let res = {content: [], totalElements: 0};
      if (params.nuCpf || params.matriculaEfpc || params.nmPessoaFisica){
        const { data } = await apiCand.get(lQuery);
        res = data;
      }
      setPessoasFisicas(res.content);
      setTotalElements(res.totalElements);

      salvarEstado(params, res.content);

      if (res.content.length === 0) {
        pessoaFisicaNaoEncontrado();
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getPessoaFisicaPorId = async (idPessoaFisica: number) => {
    try {
      setLoading(true);

      let lQuery = `pessoasFisicas/${idPessoaFisica}/full`;
      const { data } = await apiCand.get(lQuery);
      setPessoaFisica(data);

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };


  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page-1,
    });
    getPessoaFisica();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getPessoaFisica();
  };

  function salvarEstado(parametros :any, dados :any[]) {
    /* Não salvar pesquisa ao clicar em "nova consulta"

    const nmTextos = {
        entidade: form.getFieldValue("entidade") || "",
    };

    const pesq = {
      resultado: dados,
      parametros: parametros,
      nmTextos: nmTextos
    };
    salvarPesquisa('pessoasFisicas', pesq);
    */
  }

  function limparConsulta() {
    setPessoasFisicas([]);
    setPessoaFisica(undefined);
    setTotalElements(0);
    limparPesquisaSalva();
    form.resetFields();
  }

  const maskFieldCpf = (isValue: string) => {
    if (form.getFieldValue("nuCpf")) {
      isValue = form.getFieldValue("nuCpf");
    }

    form?.setFieldsValue({
      nuCpf: maskCpf(isValue),
    });
  };

  return (
    <Spin spinning={loading} >

      <>
        <PageHeader
          className="site-page-header"
          title="Consultar Pessoas Físicas"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>
          <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
            <Form.Item name="pagina" />
            <Form.Item name="linhaPorPagina" />

            <Row>
              <Col xs={12} xl={12}>
                <Form.Item label="Entidade"
                  labelCol={{ span: 24 }}
                  name="entidade"
                  colon={false}
                >
                  <Select
                    showSearch
                    filterOption
                    allowClear
                    optionFilterProp='children'
                    placeholder='Selecione a entidade'
                    // disabled={entidades.length === 1}
                    onChange={(_, index) => {
                      handlerEntidade(index);
                    }}
                  >
                    {entidades?.map((e: IEntidade) => (
                      <Option key={e.matricula} value={e.matricula}>
                        {e.sigla}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={5}>
                <Form.Item label="CPF" name="nuCpf">
                  <Input
                    value={form.getFieldValue("nuCpf")}
                    onChange={(e) => maskFieldCpf(e.target.value)}
                    placeholder="Digitar o número do CPF"
                    maxLength={14}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={12}>
                <Form.Item label="Nome" name="nmPessoaFisica">
                  <Input placeholder="Digitar o nome" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  id="consultar"
                  type="primary"
                  value="default"
                  shape="round"
                  onClick={() => getPessoaFisica()}
                >
                  Consultar
                </Button>
                <Button
                  id="limpar"
                  value="default"
                  shape="round"
                  onClick={() => limparConsulta()}
                >
                  Limpar
                </Button>
              </>
            </Row>
          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
          <Table
            // className="overflowConsulta"
            dataSource={pessoasFisicas}
            size={"small"}
            columns={columns}
            rowKey="idPessoaFisica"
            loading={loading}
            pagination={{
              defaultPageSize: DEFAULT_PAGE_SIZE,
              pageSize: pageSize,
              total: totalElements,
              showSizeChanger: true,
              onShowSizeChange: handleShowSizeChange,
              onChange: handlePaginationChange,
              pageSizeOptions: PAGE_SIZE_OPTIONS,
              locale: { items_per_page: "Linhas por página" },
            }}
          />
        </Card>
      </>
    </Spin>
  );
};

export default Consultar;
